import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from "@angular/core";
import { Link } from "@common/ADAPT.Common.Model/organisation/link";
import { SpeedCatchup } from "@common/ADAPT.Common.Model/organisation/speed-catchup";
import { Autobind } from "@common/lib/autobind.decorator/autobind.decorator";
import { of } from "rxjs";
import { switchMap, tap } from "rxjs/operators";
import { KanbanUiService } from "../../kanban/kanban-ui.service";
import { PeerCatchupService } from "../peer-catchup.service";
import { PeerCatchupAuthService } from "../peer-catchup-auth.service";
import { PeerCatchupUiService } from "../peer-catchup-ui.service";

@Component({
    selector: "adapt-catchup-link",
    templateUrl: "./catchup-link.component.html",
    styleUrl: "./catchup-link.component.scss",
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class CatchupLinkComponent implements OnInit, OnChanges {
    @Input({ required: true }) public catchupLink!: Link;

    @Input() public canEdit = false;
    @Input() public linkDisabled = false;

    @Output() public linkDeleted = new EventEmitter<void>();

    public catchup?: SpeedCatchup;
    public canEditCatchup = false;

    public constructor(
        private peerCatchupService: PeerCatchupService,
        private peerCatchupUiService: PeerCatchupUiService,
        private peerCatchupAuthService: PeerCatchupAuthService,
        private kanbanUiService: KanbanUiService,
    ) {}

    public ngOnInit(): void {
        this.peerCatchupService.getCatchupById(this.catchupLink.speedCatchupId!).pipe(
            tap((catchup) => this.catchup = catchup),
            switchMap((catchup) => catchup ? this.peerCatchupAuthService.canEditCatchup(catchup) : of(false)),
        ).subscribe((c) => this.canEditCatchup = c);
    }

    public ngOnChanges(changes: SimpleChanges): void {
        if (changes.catchupLink) {
            this.ngOnInit();
        }
    }

    public openCatchup(event: MouseEvent) {
        event.preventDefault();
        event.stopPropagation();

        if (!this.catchup || this.linkDisabled) {
            return;
        }

        this.peerCatchupUiService.showCatchup(this.catchup, true, false).subscribe();
    }

    @Autobind
    public deleteLink() {
        return this.kanbanUiService.deletePcuLink(this.catchupLink).pipe(
            tap(() => this.linkDeleted.emit()),
        );
    }
}
